const qld = {
  title: 'Queensland',
  links: [
    {
      anchorText: 'Gold Coast',
      searchAreaId: '28771',
      path: 'gold-coast-qld',
    },
    {
      anchorText: 'Gympie',
      searchAreaId: '29406',
      path: 'gympie-qld',
    },
    {
      anchorText: 'Robina',
      searchAreaId: '12622',
      path: 'robina-qld',
    },
    {
      anchorText: 'Mackay',
      searchAreaId: '29400',
      path: 'mackay-qld',
    },
    {
      anchorText: 'Townsville',
      searchAreaId: '29399',
      path: 'townsville-qld',
    },
    {
      anchorText: 'Redcliffe',
      searchAreaId: '22409',
      path: 'redcliffe-qld',
    },
    {
      anchorText: 'Bowen',
      searchAreaId: '10846',
      path: 'bowen-qld',
    },
    {
      anchorText: 'Airlie Beach',
      searchAreaId: '10828',
      path: 'airlie-beach-qld',
    },
    {
      anchorText: 'Cairns',
      searchAreaId: '29398',
      path: 'cairns-qld',
    },
    {
      anchorText: 'Sunshine Coast',
      searchAreaId: '28371',
      path: 'sunshine-coast-qld',
    },
    {
      anchorText: 'Cannonvale',
      searchAreaId: '10857',
      path: 'cannonvale-qld-4802',
    },
    {
      anchorText: 'Rockhampton',
      searchAreaId: '29402',
      path: 'rockhampton-qld',
    },
    {
      anchorText: 'Toowoomba',
      searchAreaId: '29407',
      path: 'toowoomba-qld',
    },
    {
      anchorText: 'Hervey Bay',
      searchAreaId: '29405',
      path: 'hervey-bay-qld',
    },
    {
      anchorText: 'Bundaberg',
      searchAreaId: '29404',
      path: 'bundaberg-qld',
    },
    {
      anchorText: 'Gladstone',
      searchAreaId: '30263',
      path: 'gladstone-qld',
    },
    {
      anchorText: 'Maryborough',
      searchAreaId: '14825',
      path: 'maryborough-qld',
    },
    {
      anchorText: 'Innisfail',
      searchAreaId: '10195',
      path: 'innisfail-qld',
    },
    {
      anchorText: 'Caboolture',
      searchAreaId: '29512',
      path: 'caboolture-qld-4510',
    },
    {
      anchorText: 'Yeppoon',
      searchAreaId: '11889',
      path: 'yeppoon-qld',
    },
    {
      anchorText: 'Mount Isa',
      searchAreaId: '11135',
      path: 'mount-isa-qld-4825',
    },
    {
      anchorText: 'Caloundra',
      searchAreaId: '11915',
      path: 'caloundra-qld',
    },
    {
      anchorText: 'Atherton',
      searchAreaId: '12683',
      path: 'atherton-qld',
    },
    {
      anchorText: 'Burleigh Heads',
      searchAreaId: '12511',
      path: 'burleigh-heads-qld',
    },
    {
      anchorText: 'Mareeba',
      searchAreaId: '13010',
      path: 'mareeba-qld',
    },
    {
      anchorText: 'Mission Beach',
      searchAreaId: '13035',
      path: 'mission-beach-qld',
    },
    {
      anchorText: 'Sarina',
      searchAreaId: '11032',
      path: 'sarina-qld',
    },
    {
      anchorText: 'Nambour',
      searchAreaId: '12006',
      path: 'nambour-qld',
    },
    {
      anchorText: 'Buderim',
      searchAreaId: '11910',
      path: 'buderim-qld',
    },
    {
      anchorText: 'Noosa Heads',
      searchAreaId: '12012',
      path: 'noosa-heads-qld',
    },
    {
      anchorText: 'Gracemere',
      searchAreaId: '11765',
      path: 'gracemere-qld',
    },
    {
      anchorText: 'Highfields',
      searchAreaId: '23118',
      path: 'highfields-qld',
    },
    {
      anchorText: 'Edmonton',
      searchAreaId: '10161',
      path: 'edmonton-qld',
    },
    {
      anchorText: 'Kingaroy',
      searchAreaId: '29408',
      path: 'kingaroy-qld',
    },
    {
      anchorText: 'Emerald',
      searchAreaId: '29401',
      path: 'emerald-qld',
    },
    {
      anchorText: 'Trinity Beach',
      searchAreaId: '10288',
      path: 'trinity-beach-qld',
    },
    {
      anchorText: 'Bribie Island',
      searchAreaId: '23638',
      path: 'bribie-island-qld',
    },
    {
      anchorText: 'Proserpine',
      searchAreaId: '11017',
      path: 'proserpine-qld',
    },
    {
      anchorText: 'Palm Beach',
      searchAreaId: '14540',
      path: 'palm-beach-qld',
    },
    {
      anchorText: 'Whitsundays',
      searchAreaId: '11070',
      path: 'whitsundays-qld',
    },
    {
      anchorText: 'Coolum Beach',
      searchAreaId: '11927',
      path: 'coolum-beach-qld',
    },
    {
      anchorText: 'Childers',
      searchAreaId: '14738',
      path: 'childers-qld',
    },
    {
      anchorText: 'Maroochydore',
      searchAreaId: '11987',
      path: 'maroochydore-qld',
    },
    {
      anchorText: 'Runaway Bay',
      searchAreaId: '12626',
      path: 'runaway-bay-qld',
    },
    {
      anchorText: 'Mudgeeraba',
      searchAreaId: '12588',
      path: 'mudgeeraba-qld',
    },
    {
      anchorText: 'Tully',
      searchAreaId: '13034',
      path: 'tully-qld',
    },
    {
      anchorText: 'Southport',
      searchAreaId: '14533',
      path: 'southport-qld',
    },
    {
      anchorText: 'Kirwan',
      searchAreaId: '12316',
      path: 'kirwan-qld',
    },
    {
      anchorText: 'Nanango',
      searchAreaId: '15064',
      path: 'nanango-qld',
    },
    {
      anchorText: 'Upper Coomera',
      searchAreaId: '12658',
      path: 'upper-coomera-qld',
    },
    {
      anchorText: 'Tewantin',
      searchAreaId: '12054',
      path: 'tewantin-qld',
    },
    {
      anchorText: 'Ingham',
      searchAreaId: '13521',
      path: 'ingham-qld',
    },
    {
      anchorText: 'Ormeau',
      searchAreaId: '22710',
      path: 'ormeau-qld',
    },
    {
      anchorText: 'Helensvale',
      searchAreaId: '12555',
      path: 'helensvale-qld',
    },
    {
      anchorText: 'Nerang',
      searchAreaId: '12592',
      path: 'nerang-qld',
    },
    {
      anchorText: 'North Lakes',
      searchAreaId: '23645',
      path: 'north-lakes-qld',
    },
    {
      anchorText: 'Bargara',
      searchAreaId: '14695',
      path: 'bargara-qld',
    },
    {
      anchorText: 'Glenwood',
      searchAreaId: '14786',
      path: 'glenwood-qld',
    },
    {
      anchorText: 'Noosaville',
      searchAreaId: '12020',
      path: 'noosaville-qld',
    },
    {
      anchorText: 'Yandina',
      searchAreaId: '12069',
      path: 'yandina-qld',
    },
    {
      anchorText: 'Kuranda',
      searchAreaId: '10208',
      path: 'kuranda-qld',
    },
    {
      anchorText: 'Gordonvale',
      searchAreaId: '10184',
      path: 'gordonvale-qld',
    },
    {
      anchorText: 'Ashmore',
      searchAreaId: '12484',
      path: 'ashmore-qld',
    },
    {
      anchorText: 'Cooroy',
      searchAreaId: '11932',
      path: 'cooroy-qld',
    },
    {
      anchorText: 'Beerwah',
      searchAreaId: '11899',
      path: 'beerwah-qld',
    },
    {
      anchorText: 'Gin Gin',
      searchAreaId: '14779',
      path: 'gin-gin-qld',
    },
    {
      anchorText: 'Smithfield',
      searchAreaId: '10274',
      path: 'smithfield-qld',
    },
    {
      anchorText: 'Gayndah',
      searchAreaId: '14778',
      path: 'gayndah-qld',
    },
    {
      anchorText: 'Woodford',
      searchAreaId: '14616',
      path: 'woodford-qld',
    },
    {
      anchorText: 'Malanda',
      searchAreaId: '13007',
      path: 'malanda-qld',
    },
    {
      anchorText: 'Howard',
      searchAreaId: '14802',
      path: 'howard-qld',
    },
    {
      anchorText: 'Mooloolaba',
      searchAreaId: '11995',
      path: 'mooloolaba-qld',
    },
    {
      anchorText: 'Currumbin',
      searchAreaId: '12534',
      path: 'currumbin-qld',
    },
    {
      anchorText: 'Port Douglas',
      searchAreaId: '10261',
      path: 'port-douglas-qld',
    },
    {
      anchorText: 'Oxenford',
      searchAreaId: '12607',
      path: 'oxenford-qld',
    },
    {
      anchorText: 'Biloela',
      searchAreaId: '11698',
      path: 'biloela-qld',
    },
    {
      anchorText: 'Bli Bli',
      searchAreaId: '11905',
      path: 'bli-bli-qld',
    },
    {
      anchorText: 'Morayfield',
      searchAreaId: '14223',
      path: 'morayfield-qld',
    },
    {
      anchorText: 'Mossman',
      searchAreaId: '10233',
      path: 'mossman-qld',
    },
    {
      anchorText: 'Burpengary',
      searchAreaId: '23634',
      path: 'burpengary-qld',
    },
    {
      anchorText: 'Moore Park Beach',
      searchAreaId: '14839',
      path: 'moore-park-beach-qld',
    },
    {
      anchorText: 'Pacific Pines',
      searchAreaId: '12609',
      path: 'pacific-pines-qld',
    },
    {
      anchorText: 'Warwick',
      searchAreaId: '23299',
      path: 'warwick-qld',
    },
    {
      anchorText: 'Coolangatta',
      searchAreaId: '12398',
      path: 'coolangatta-qld',
    },
    {
      anchorText: 'Hope Island',
      searchAreaId: '12560',
      path: 'hope-island-qld',
    },
    {
      anchorText: 'Pomona',
      searchAreaId: '12041',
      path: 'pomona-qld',
    },
    {
      anchorText: 'Redlynch',
      searchAreaId: '10267',
      path: 'redlynch-qld',
    },
    {
      anchorText: 'Oakey',
      searchAreaId: '23393',
      path: 'oakey-qld',
    },
    {
      anchorText: 'Walkerston',
      searchAreaId: '11065',
      path: 'walkerston-qld',
    },
    {
      anchorText: 'Paradise Point',
      searchAreaId: '12611',
      path: 'paradise-point-qld',
    },
    {
      anchorText: 'Maleny',
      searchAreaId: '11980',
      path: 'maleny-qld',
    },
    {
      anchorText: 'Agnes Water',
      searchAreaId: '11677',
      path: 'agnes-water-qld',
    },
    {
      anchorText: 'Burleigh Waters',
      searchAreaId: '12516',
      path: 'burleigh-waters-qld',
    },
    {
      anchorText: 'Marian',
      searchAreaId: '10959',
      path: 'marian-qld',
    },
    {
      anchorText: 'Arundel',
      searchAreaId: '12481',
      path: 'arundel-qld',
    },
    {
      anchorText: 'Broadbeach',
      searchAreaId: '12500',
      path: 'broadbeach-qld',
    },
    {
      anchorText: 'Landsborough',
      searchAreaId: '11976',
      path: 'landsborough-qld',
    },
    {
      anchorText: 'Mount Morgan',
      searchAreaId: '11807',
      path: 'mount-morgan-qld',
    },
    {
      anchorText: 'Mooloolah Valley',
      searchAreaId: '11998',
      path: 'mooloolah-valley-qld',
    },
    {
      anchorText: 'Tin Can Bay',
      searchAreaId: '14357',
      path: 'tin-can-bay-qld',
    },
  ],
};

export { qld };
